export default __webpack_public_path__ + "static/media/357.53ed1f9a.jpg";